import { Container, Row, Col } from 'reactstrap'
import { Title } from './Title'
import { GeneralInfo } from './GeneralInfo'
import { AboutInfo } from './AboutInfo'
import { ContactActions } from './ContactActions'

const ContactDetails = ({ contact, roles, deals }) => {
  const {
    firstName,
    lastName,
    facebook,
    twitter,
    linkedin,
    instagram,
    title,
    company,
    cellPhone,
    phone,
    email,
    status,
    priority,
    birthday,
    partner,
    partnerBirthday,
    label,
    about,
    phoneExt,
    salutation,
    fax,
    accountOwner,
    breadCrumb
  } = contact
  return (
    <Container>
      <Row>
        <Col lg="6">
          <Title
            salutation={salutation}
            firstName={firstName}
            lastName={lastName}
            facebook={facebook}
            twitter={twitter}
            linkedin={linkedin}
            instagram={instagram}
            title={title}
            company={company}
            breadCrumb={breadCrumb}
          />
        </Col>
        <Col lg="6">
          <ContactActions contact={contact} deals={deals} />
        </Col>
      </Row>
      <Row>
        <Col lg="12">
          <GeneralInfo
            cellPhone={cellPhone}
            phone={phone}
            email={email}
            priority={priority}
            birthday={birthday}
            partner={partner}
            partnerBirthday={partnerBirthday}
            label={label}
            status={status}
            roles={roles}
            phoneExt={phoneExt}
            fax={fax}
            accountOwner={accountOwner}
          />
          <AboutInfo about={about} />
        </Col>
      </Row>
    </Container>
  )
}

export default ContactDetails
